import React, { useState } from "react";
import styled from "styled-components";

import Collapse from "@material-ui/core/Collapse";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

import { fnChatUseStyles } from "../styles";
import { cx } from "../lib/utils";

export default function FunctionChat({ assistantLogo, content, loading }) {
  const classes = fnChatUseStyles();

  const [expanded, setExpanded] = useState(true);

  const handleToggleExpansion = () => {
    setExpanded((prevState) => !prevState);
  };

  const renderFunctionChat = () => {
    return (
      <Container>
        <Header>
          <AssistantAuthorContainer>{assistantLogo}</AssistantAuthorContainer>
          <Assistant>ASSISTANT</Assistant>
        </Header>
        <Button
          startIcon={loading ? <CircularProgress size={12} /> : null}
          onClick={handleToggleExpansion}
        >
          {expanded ? (
            <span>
              Hide Content <ExpandLessIcon />
            </span>
          ) : (
            <span>
              Show Content <ExpandMoreIcon />
            </span>
          )}
        </Button>
        <Collapse in={expanded}>
          <div
            className={cx(
              classes.contentRoot,
              classes.content,
              loading && classes.contentLoading
            )}
          >
            {content}
          </div>
        </Collapse>
      </Container>
    );
  };

  return renderFunctionChat();
}

FunctionChat.propTypes = {};

FunctionChat.defaultProps = {};

const Container = styled.div`
  & {
    width: 100%;
    padding: 1rem 1.5rem;
  }
`;

const Header = styled.div`
  & {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding-bottom: 0.5rem;
  }
`;

const AssistantAuthorContainer = styled.div`
  & {
    height: 20px;
    width: 20px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) =>
      props.themeColor || props.theme.palette.primary.main};
  }
`;

const Assistant = styled.div`
  & {
    fontsize: 11px;
    text-transform: uppercase;
    color: ${(props) => props.themeColor || props.theme.palette.primary.main};
  }
`;
